/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "./has.js";

function n(n) {}

function t(n) {}

function o(n) {
  return function () {
    return n;
  };
}

var c = function c() {
  for (var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++) {
    n[_key] = arguments[_key];
  }

  return n;
};

export { n as neverReached, t as neverReachedSilent, c as tuple, o as typeCast };